export default __webpack_public_path__ + "cfe41ec8f836f8c0c3f770a8475ee198.png";